(ns hypnos.consumer.panels.footer
  "The footer."
  (:require [hypnos.config :as config]
            [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; panels

(defn panel
  "The footer"
  []
  [:footer.footer
   [:div.container-fluid
    [:div.level
     [:div.level-left]
     [:div.right-left
      [:div.level-item [:p.content.is-small (str (tr :ui.label/copyright)) " " (tr :ui.label/version config/VERSION)]]]]]])
